import { sendToExtension, createPageMayExitObservable, willSyntheticsInjectRum, canUseEventBridge, startAccountContext, startGlobalContext, startTelemetry, createIdentityEncoder, startUserContext } from '@datadog/browser-core';
import { startLogsSessionManager, startLogsSessionManagerStub } from '../domain/logsSessionManager';
import { startLogsAssembly } from '../domain/assembly';
import { startConsoleCollection } from '../domain/console/consoleCollection';
import { startReportCollection } from '../domain/report/reportCollection';
import { startNetworkErrorCollection } from '../domain/networkError/networkErrorCollection';
import { startRuntimeErrorCollection } from '../domain/runtimeError/runtimeErrorCollection';
import { LifeCycle } from '../domain/lifeCycle';
import { startLoggerCollection } from '../domain/logger/loggerCollection';
import { startLogsBatch } from '../transport/startLogsBatch';
import { startLogsBridge } from '../transport/startLogsBridge';
import { startInternalContext } from '../domain/contexts/internalContext';
import { startReportError } from '../domain/reportError';
import { createHooks } from '../domain/hooks';
import { startRUMInternalContext } from '../domain/contexts/rumInternalContext';
import { startSessionContext } from '../domain/contexts/sessionContext';
var LOGS_STORAGE_KEY = 'logs';
export function startLogs(configuration, getCommonContext, // `startLogs` and its subcomponents assume tracking consent is granted initially and starts
// collecting logs unconditionally. As such, `startLogs` should be called with a
// `trackingConsentState` set to "granted".
trackingConsentState, bufferedDataObservable) {
  var lifeCycle = new LifeCycle();
  var hooks = createHooks();
  var cleanupTasks = [];
  lifeCycle.subscribe(1
  /* LifeCycleEventType.LOG_COLLECTED */
  , function (log) {
    return sendToExtension('logs', log);
  });
  var reportError = startReportError(lifeCycle);
  var pageMayExitObservable = createPageMayExitObservable(configuration);
  var telemetry = startTelemetry("browser-logs-sdk"
  /* TelemetryService.LOGS */
  , configuration, hooks, reportError, pageMayExitObservable, createIdentityEncoder);
  cleanupTasks.push(telemetry.stop);
  var session = configuration.sessionStoreStrategyType && !canUseEventBridge() && !willSyntheticsInjectRum() ? startLogsSessionManager(configuration, trackingConsentState) : startLogsSessionManagerStub(configuration); // Start user and account context first to allow overrides from global context

  startSessionContext(hooks, configuration, session);
  var accountContext = startAccountContext(hooks, configuration, LOGS_STORAGE_KEY);
  var userContext = startUserContext(hooks, configuration, session, LOGS_STORAGE_KEY);
  var globalContext = startGlobalContext(hooks, configuration, LOGS_STORAGE_KEY, false);

  var _startRUMInternalCont = startRUMInternalContext(hooks),
      _stop = _startRUMInternalCont.stop;

  startNetworkErrorCollection(configuration, lifeCycle);
  startRuntimeErrorCollection(configuration, lifeCycle, bufferedDataObservable);
  bufferedDataObservable.unbuffer();
  startConsoleCollection(configuration, lifeCycle);
  startReportCollection(configuration, lifeCycle);

  var _startLoggerCollectio = startLoggerCollection(lifeCycle),
      handleLog = _startLoggerCollectio.handleLog;

  startLogsAssembly(configuration, lifeCycle, hooks, getCommonContext, reportError);

  if (!canUseEventBridge()) {
    var _startLogsBatch = startLogsBatch(configuration, lifeCycle, reportError, pageMayExitObservable, session),
        stopLogsBatch = _startLogsBatch.stop;

    cleanupTasks.push(function () {
      return stopLogsBatch();
    });
  } else {
    startLogsBridge(lifeCycle);
  }

  var internalContext = startInternalContext(session);
  return {
    handleLog: handleLog,
    getInternalContext: internalContext.get,
    accountContext: accountContext,
    globalContext: globalContext,
    userContext: userContext,
    stop: function stop() {
      cleanupTasks.forEach(function (task) {
        return task();
      });

      _stop();
    }
  };
}